import React, { useState, useEffect } from "react";
import ImageLoader from "../common/ImageLoader";

import heroImage from "../../../assets/images/technology/technology-hero.jpg";
import heroImageWebp from "../../../assets/images/technology/technology-hero.jpg?as=webp";
import heroImageSm from "../../../assets/images/technology/technology-hero-sm.jpg";
import heroImageSmWebp from "../../../assets/images/technology/technology-hero-sm.jpg?as=webp";

function Hero() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoaded(true);
    }, 500);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className={`technology-hero ${isLoaded ? "is-loaded" : ""}`}>
      <ImageLoader
        className="technology-hero__image"
        image={heroImage}
        webp={heroImageWebp}
        smallImage={heroImageSm}
        smallWebp={heroImageSmWebp}
        alt="Technology"
        placeholderAspectRatio={1569 / 973}
        responsiveWidth={480}
        noLazyLoad
      >
        <div className="technology-hero__content">
          <h1 className="technology-hero__title">
            Mila is more than a purifier,
            <br /> she's your partner in creating a healthier home.
          </h1>
          <div className="technology-hero__description">
            <p>
              Mila solves an age old problem: nobody really knows WTF is in
              their air. Because you know, air is invisible...
            </p>
          </div>
        </div>
      </ImageLoader>
    </div>
  );
}

export default Hero;
